module.exports = __webpack_public_path__ + "32a7d4b7dd2884294553b1b4de73dbe5.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1085
// module chunks = 0